import { z } from 'zod';
import { teamsAppStatusSchema } from '#src/access/access.contract.js';
import { authModeSchema } from '#src/auth/auth-config.contract.js';
import { permissionSchema } from '#src/auth/permissions.contract.js';
/**
 * Perfil básico da pessoa no diretório (Microsoft Graph), com a permissão que
 * o app já tem (`User.ReadBasic.All`): nada além disso vem sem pedir mais.
 */
export const directoryProfileSchema = z.strictObject({
    id: z.string(),
    displayName: z.string().nullable(),
    givenName: z.string().nullable(),
    surname: z.string().nullable(),
    mail: z.string().nullable(),
    userPrincipalName: z.string().nullable(),
});
/**
 * Resposta de `GET /api/teams/me`: o que o servidor sabe de quem chama. O
 * contexto do Teams e as declarações do token SSO a página lê no navegador.
 */
export const teamsUserReportSchema = z.strictObject({
    /** Como o backend autentica: `entra` (SSO assinado) ou `dev` (sem assinatura). */
    authMode: authModeSchema,
    identity: z.strictObject({
        userId: z.uuid(),
        /** `oid` do Entra ID; nulo até o primeiro acesso pelo SSO. */
        entraObjectId: z.string().nullable(),
        name: z.string(),
        email: z.string(),
        roles: z.array(z.string()),
        permissions: z.array(permissionSchema),
    }),
    directory: z.discriminatedUnion('state', [
        z.strictObject({
            state: z.literal('found'),
            /** Por onde a pessoa foi achada: o `oid` ou o e-mail (modo dev). */
            lookup: z.enum(['entraObjectId', 'email']),
            profile: directoryProfileSchema,
        }),
        z.strictObject({ state: z.literal('not-found') }),
        z.strictObject({ state: z.literal('unavailable'), detail: z.string() }),
    ]),
    teamsApp: teamsAppStatusSchema,
});
//# sourceMappingURL=teams-user.contract.js.map